var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.disabled},on:{"click":_vm.download}},[_vm._v("\n  دانلود اکسل\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }